<template>
  <v-flex
    style="display: flex; border-bottom: 1px solid #eee"
    :style="`${event.isKey || event.isSuperPoint ? 'background-color: #EBF8FF' : ''}`"
    justify-start
  >
    <PlayerModal
      :show="show"
      :selectedPlayer="selectedPlayer"
      @close="show = false; selectedPlayer = null"
    />

    <f-time :offset="event.endTimeOffset" style="width: 10%"></f-time>
    <v-tooltip top style="width: 10%">
      <template slot="activator">
        <v-icon>view_list</v-icon>
        <small>{{ event.no.toString().padStart(3, 0) }}</small>
      </template>
      <span>Rally</span>
    </v-tooltip>

    <h3 v-if="!event.events">{{ event.pointsTeamA }} - {{ event.pointsTeamB }}</h3>

    <div
      v-if="event.events"
      style="display:flex; flex-grow: 1; justify-content: center; flex-direction: column"
    >
      <v-flex
        v-for="(action, $index) in filteredActions"
        :key="action.identifier"
        style="display: flex; align-items: center; justify-content: flex-start; padding: 0"
      >
        <small style="width: 10%">
          <f-time :offset="action.timeOffset" v-if="action.timeOffset"></f-time>
        </small>
        <template v-if="action.noPlayer && action.code !== 'ChallengeRequest'">
          <f-flag
            v-if="teamA.players.indexOf(action.noPlayer) !== -1"
            :code="teamA.code"
            :height="20"
            :alt="teamA.code"
          ></f-flag>
          <f-flag
            v-if="teamB.players.indexOf(action.noPlayer) !== -1"
            :code="teamB.code"
            :height="20"
            :alt="teamB.code"
          ></f-flag>
          <span
            style="width: 5%; cursor: pointer;"
            v-if="players[action.noPlayer]"
            @click.stop="showDialog(players[action.noPlayer], teamA.players.indexOf(action.noPlayer) !== -1 ? teamA.code : teamB.code)"
          >{{ players[action.noPlayer].noShirt }}</span>
          <span
            style="text-align: left; width: 20%; cursor: pointer;"
            v-if="players[action.noPlayer]"
            @click.stop="showDialog(players[action.noPlayer], teamA.players.indexOf(action.noPlayer) !== -1 ? teamA.code : teamB.code)"
          >{{ players[action.noPlayer].volleyballPlayer.teamNamePlayer }}</span>
        </template>

        <template
          v-if="!action.noPlayer && action.code !== 'ChallengeRequest' && action.code !== 'ChallengeResult'"
        >
          <f-flag :code="teams[action.noTeam].code" :height="20" :alt="teams[action.noTeam].code"></f-flag>
          <div style="width: 5%"></div>
          <span
            style="text-align: left; width: 20%"
            v-if="action.code == 'TeamPoint' && action.note == 2"
          >Team Fault</span>
          <span
            style="text-align: left; width: 20%"
            v-if="action.code == 'TeamPoint' && action.note == 3"
          >Opp. Error</span>
        </template>

        <template v-if="action.code === 'ChallengeRequest'">
          <f-flag :code="teams[action.noTeam].code" :height="20" :alt="teams[action.noTeam].code"></f-flag>
          <div style="width: 5%"></div>
          <strong style="text-align: left; width: 20%">Challenge Requested</strong>
          <span style="text-align: left; width: 20%">{{ challengeTypes[action.type] }}</span>
        </template>

        <template v-if="action.code === 'ChallengeResult'">
          <div style="width: 5%; margin-left: 30px"></div>
          <strong style="text-align: left; width: 20%">Challenge Result</strong>
          <v-tooltip top style="width: 7%; margin-right: 20px">
            <template v-if="action.outcome == 1">
              <v-icon small slot="activator">remove</v-icon>
              <span>Canceled</span>
            </template>

            <template v-if="action.outcome == 2">
              <v-icon small slot="activator">done</v-icon>
              <span>Team is right</span>
            </template>

            <template v-if="action.outcome == 3">
              <v-icon small slot="activator">clear</v-icon>
              <span>Team is wrong</span>
            </template>

            <template v-if="action.outcome == 4">
              <v-icon small slot="activator">block</v-icon>
              <span>Unjudgeable</span>
            </template>
          </v-tooltip>
        </template>

        <span
          style="width: 7%"
          v-if="action.code !== 'ChallengeRequest' && action.code !== 'ChallengeResult'"
        >{{ skills[action.skill] }}</span>

        <template v-if="action.code !== 'ChallengeRequest'">
          <v-icon
            small
            style="width: 10px"
            v-if="action.note == 3 && ([1,4,6].indexOf(action.skill) != -1 || action.code == 'TeamPoint')"
          >add</v-icon>
          <v-icon
            small
            style="width: 10px"
            v-if="action.note == 1 && [2,3,5].indexOf(action.skill) != -1"
          >explicit</v-icon>
          <v-icon small style="width: 10px" v-if="action.note == 2">remove</v-icon>
          <v-icon small style="width: 10px" v-if="action.note == 4">add_circle</v-icon>
          <v-icon small style="width: 10px; margin-left: 20px" v-if="action.isKey">stars</v-icon>
          <v-icon small style="width: 10px; margin-left: 20px" v-if="action.isSuperServe">keyboard_double_arrow_up</v-icon>
        </template>

        <template v-if="$index === event.events.length - 1">
          <h3
            :style="{ marginLeft: action.isKey ? '30px' : '60px' }"
          >{{ event.pointsTeamA }} - {{ event.pointsTeamB }}</h3>
        </template>
      </v-flex>
    </div>
  </v-flex>
</template>

<script>
import Time from "./Time";
import Flag from "@/components/Flag";
import PlayerModal from "@/components/MatchLive/PlayerModal/PlayerModal.vue";

export default {
  props: ["event", "teams", "players", "teamA", "teamB", "filter"],

  data: () => ({
    actions: [],
    skills: {
      1: "BLK",
      2: "DIG",
      3: "REC",
      4: "SRV",
      5: "SET",
      6: "ATK"
    },
    challengeTypes: {
      1: "Antenna Touch",
      2: "Attack Line Fault",
      3: "Ball In Out",
      4: "Block Touch",
      5: "Center Line Fault",
      6: "Net Touch",
      7: "Service Line Fault",
      8: "Floor Touch"
    },
    show: false,
    selectedPlayer: null
  }),

  computed: {
    filteredActions() {
      if (this.filter == -1) {
        return this.actions;
      }

      return this.actions.filter(action => action.skill === this.filter);
    }
  },

  components: {
    PlayerModal,
    "f-time": Time,
    "f-flag": Flag
  },

  created() {
    this.actions = this.event.events;
  },

  methods: {
    showDialog(item, teamCode) {
      this.show = true;
      this.selectedPlayer = {
        noPlayer: item.no,
        noShirt: item.noShirt,
        teamCode: teamCode
      };
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/MatchLive/PlayByPlay/Rally.vue